<div class="main-container">
  <div class="header">
    <div class="checkbox-icon">
      <div class="column-checkbox"></div>
      <div class="column-img"></div>
      <div class="column-name">{{ "taxReturns.file-name" | transloco }}</div>
    </div>

    <div class="column-update">{{ "taxReturns.last-updated" | transloco }}</div>
    <div class="column-type">{{ "taxReturns.file-type" | transloco }}</div>
    <div class="column-size">{{ "taxReturns.file-size" | transloco }}</div>
  </div>
  <div class="list-container">
    @for (child of children; track child) {
    <div class="child-item">
      <div class="checkbox-icon">
        <input
          class="child-checkbox column-checkbox"
          type="checkbox"
          [ngModel]="isChildSelected(child)"
          (click)="onCheckboxClick(child)"
        />
        @if (child.wstype==='folder') {
        <img
          class="child-img column-img clickable"
          src="assets/rubix-documents/folder_black_24dp.svg"
          alt="folder"
          (click)="toFolder(child)"
        />
        } @if (child.wstype!=='folder') {
        <img
          class="child-img column-img clickable"
          src="assets/rubix-documents/description_black_24dp.svg"
          alt="folder"
          (click)="onCheckboxClick(child)"
        />
        }
        <div
          [title]="getTitle(child)"
          class="child-name column-name clickable"
          (click)="
            child.wstype === 'folder' ? toFolder(child) : onCheckboxClick(child)
          "
        >
          {{ child.name }}
        </div>
      </div>
      <div class="child-update column-update">
        {{ getDateString(child.edit_date) }}
      </div>
      <div class="child-type column-type">
        {{
          child.wstype === "folder"
            ? "Folder"
            : child.extension.toUpperCase() + " Document"
        }}
      </div>
      <div class="child-size column-size">{{ getSize(child) }}</div>
    </div>
    }
  </div>
</div>
